<ls-breadcrumb currentLocation="Task history"></ls-breadcrumb>
<ls-page>
  <div class="o-layout__item c-card">
    <h5
      class="c-card__title"
      i18n="Task Overview|Table title for tasks @@taskOverviewTaskTitle"
    >
      Tasks
    </h5>
    <div class="c-card__content">
      <div class="c-table__responsive u-border-raduis u-border-0">
        <ls-table [cols]="5" [loading]="loading$ | async">
          <thead>
            <tr>
              <th>
                <span
                  i18n="Task Overview|Table header for task type @@taskOverviewTaskType"
                  >Task type</span
                >
              </th>
              <th>
                <span
                  i18n="Task Overview|Table header for task name @@taskOverviewTaskName"
                  >Task name</span
                >
              </th>
              <th>
                <span
                  i18n="Task Overview|Table header for task date @@taskOverviewTaskDate"
                  >Date</span
                >
              </th>
              <th class="u-align-right">
                <span
                  i18n="Task Overview|Table header for task status @@taskOverviewTaskStatus"
                  >Status</span
                >
              </th>
              <th class="u-align-right">
                <span
                  i18n="Task Overview|Table header for task action @@taskOverviewTaskAction"
                  >Action</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let task of (tasks$ | async)">
              <td>{{ task.type }}</td>
              <td>{{ task.name }}</td>
              <td>{{ task.startDate | amDateFormat: 'LL' }}</td>
              <td class="u-align-right">
                <span class="c-label" [ngClass]="'c-label--' + task.status">{{
                  getStatus(task) | lsTranslate
                }}</span>
              </td>
              <td class="u-align-right">
                <button
                  *ngIf="task.feedback"
                  class="task-feedback-action"
                  (click)="getResult(task)"
                >
                  <ng-container [ngSwitch]="task.status">
                    <span
                      *ngSwitchCase="'success'"
                      i18n="Task Status|Download action when a task is completed @@taskStatusDownload"
                      >Download</span
                    >
                    <span
                      *ngSwitchDefault
                      i18n="Task Status|Error action when a task failed @@taskStatusErrorAction"
                      >View errors</span
                    >
                  </ng-container>
                </button>
              </td>
            </tr>
          </tbody>
        </ls-table>
      </div>
    </div>
  </div>
</ls-page>
<div
  i18n="Task Overview|Breadcrumb for task overview @@taskOverviewBreadcrumb"
  id="Task history"
  ls-dynamic-translation
>
  Task history
</div>
<div
  i18n="Task Overview|Status for task @@taskOverviewSuccessfulStatus"
  id="Successful"
  ls-dynamic-translation
>
  Successful
</div>
<div
  i18n="Task Overview|Status for task @@taskOverviewFailedStatus"
  id="Failed"
  ls-dynamic-translation
>
  Failed
</div>
<div
  i18n="Task Overview|Status for task @@taskOverviewWarningStatus"
  id="Imported with errors"
  ls-dynamic-translation
>
  Imported with errors
</div>
<div
  i18n="Task Overview|Status for task @@taskOverviewRunningStatus"
  id="Running"
  ls-dynamic-translation
>
  Running
</div>
